<template>
  <div :class="[$options.name]">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneDropdownContent",
  setup() {
    return {};
  },
});
</script>

<style scoped>
@reference "vue-app/assets/scss/main.css";

.EdroneDropdownContent {
  width: 240px;
  box-shadow: 4px 4px 24px rgba(0, 0, 0, 0.22);
  border-radius: 4px;
  @apply tw:bg-white tw:border tw:border-default-200;
}
</style>
